/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase } from 'js-convert-case';
import { StorageModule } from '@vlinder-web/storage-module-react';

const storageService = StorageModule?.getInstance();
const _localData = storageService.get('userProfile', 'local');
const _sessionData = storageService.get('userProfile', 'session');
const profileData = _sessionData ?? _localData;
export interface IUserMethods extends IPluginMethodMap {
  getUserProfile(args: any): Promise<any>;
}

export class UserService implements IAgentPlugin {
  readonly methods: IUserMethods;

  constructor() {
    this.methods = {
      getUserProfile: this.getUserProfile.bind(this),
    };
  }

  async getUserProfile(args: any) {
    return {
      userName: this.getUserName({
        firstName: profileData?.name,
        lastName: '',
      }),
      userImage: this.getUserImage({
        firstName: profileData?.name,
        lastName: '',
      }),
    };
  }

  private getUserName(data: any) {
    if (profileData?.name) {
      return `${toHeaderCase(profileData?.name)}`;
    }
  }

  private getUserImage(data: any) {
    if (profileData?.logo) {
      return profileData?.logo;
    } else {
      return `https://ui-avatars.com/api/?name=${profileData?.name}&background=0D8ABC&color=fff`;
    }
  }
}
